import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useUser } from "@/services/auth-service";
import WhimsicalBackground from "@/components/WhimsicalBackground";

export const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div className="grid place-items-center">
            <WhimsicalBackground />

            <div className="relative z-10 flex flex-col items-center justify-center p-4">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="max-w-md text-center"
                >
                    <h1 className="mb-4 text-6xl font-bold">Oops!</h1>
                    <h2 className="mb-6 text-2xl font-semibold">
                        This page seems to have wandered off into a magical forest...
                    </h2>
                    <p className="mb-8 text-lg text-muted-foreground">
                        Don't worry! Let's go back to where the stories are.
                    </p>
                    <div className="space-y-4">
                        <div className="flex flex-col-reverse justify-center gap-4 sm:flex-row sm:gap-0">
                            <Button
                                variant="outline"
                                onClick={() => navigate(-1)}
                                className="w-full mr-4 sm:w-auto sm:ml-4 dark:text-slate-50"
                            >
                                Go Back
                            </Button>
                            <Button
                                onClick={() => navigate('/home')}
                                className="w-full sm:w-auto"
                            >
                                Return Home
                            </Button>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export const UnauthorizedPage = () => {
    const navigate = useNavigate();
    const user = useUser();

    let isAuthenticated = false;
    if (user?.email) {
        isAuthenticated = true;
    }

    return (
        <div className="grid place-items-center">
            <WhimsicalBackground />

            <div className="relative z-10 flex flex-col items-center justify-center p-4">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="max-w-md text-center"
                >
                    {isAuthenticated ? (
                        <>
                            <h1 className="mb-4 text-6xl font-bold">Oops!</h1>
                            <h2 className="mb-6 text-2xl font-semibold">
                                You don't have access to this magical realm
                            </h2>
                            <p className="mb-8 text-lg text-muted-foreground">
                                It seems you need special permissions to enter this area.
                            </p>
                            <Button
                                variant="outline"
                                onClick={() => navigate(-1)}
                                className="w-full sm:w-auto dark:text-slate-50"
                            >
                                Go Back
                            </Button>
                        </>
                    ) : (
                        <>
                            <h1 className="mb-4 text-6xl font-bold">Oh My!</h1>
                            <h2 className="mb-6 text-2xl font-semibold">
                                This magical door needs a special key...
                            </h2>
                            <p className="mb-8 text-lg text-muted-foreground">
                                Please sign in to access this enchanted realm.
                            </p>
                            <div className="space-y-4">
                                <div className="flex flex-col-reverse justify-center gap-4 sm:flex-row sm:gap-0">
                                    <Button
                                        variant="outline"
                                        onClick={() => navigate("/home")}
                                        className="w-full mr-4 sm:w-auto sm:ml-4 dark:text-slate-50"
                                    >
                                        Go Home
                                    </Button>
                                    <Button
                                        onClick={() => navigate('/signin')}
                                        className="w-full sm:w-auto"
                                    >
                                        Sign In
                                    </Button>
                                </div>
                            </div>
                        </>
                    )}
                </motion.div>
            </div>
        </div>
    );
};
